<template>
  <div id="relListCli">
    <section class="card mt-4">
      <b-card-header
        header="Clientes com pendência financeira"
        header-text-variant="white"
        header-tag="header"
        :style="cor"
      />
      <b-card class="cardBody">
        <div>
          <b-pagination-nav size="sm" :number-of-pages="pObjPaginacao.length" :pages="pObjPaginacao"  v-model="current_page" @input="buscarClientesPorPagina" align="right" use-router></b-pagination-nav>
        </div>
        <b-card-text class="table">
          <b-table bordered striped :items="clientes" :fields="fieldsClientes">
            <template slot="mobile" slot-scope="row">
              <div class="form-row mb-1">
                <div class="col-md-8"><strong>{{toCapitalize(row.item.fantasia)}}</strong></div>
                <div class="col-md-4 txtRight"><strong>Cód.: {{row.item.codCliente}}</strong></div>
              </div>
              <div class="form-row mb-1">
                <div class="col-md-8">{{toCapitalize(row.item.razaoSocial)}}</div>
                <div class="col-md-4 txtRight">{{row.item.telefone}}</div>
                </div>
              <div class="form-row mb-1">
                <div class="col-md-8" v-if="row.item.cnpjCpf.length === 14">CNPJ: {{formatterCnpjCpf(row.item.cnpjCpf)}}</div>
                <div class="col-md-8" v-else>CPF: {{formatterCnpjCpf(row.item.cnpjCpf)}}</div>
                <div class="col-md-4 txtRight">{{row.item.email}}</div>
              </div>
              <div class="form-row mb-1">
                <div class="col-md-8 text-danger">Vencimento: {{row.item.vencimento}}</div>
                <div class="col-md-4 txtRight text-danger">R$ {{formatterValue(row.item.valor)}}</div>
              </div>
            </template>
          </b-table>
        </b-card-text>
        <div class="mt-3">
          <b-pagination-nav size="sm" :number-of-pages="pObjPaginacao.length" :pages="pObjPaginacao"  v-model="current_page" @input="buscarClientesPorPagina" align="right" use-router></b-pagination-nav>
        </div>
      </b-card>
    </section>
    <BlockUI v-if="blockUI.visibility" :message="blockUI.message">
      <spinner-vue  id="modal-xl" ></spinner-vue>
    </BlockUI>
  </div>
</template>
<script>
  import relatoriosService from '@/services/relatorios'
  import ToastVue from '../layouts/toastVue'
  import spinnerVue from '@/components/items/SpinnerVue'
  export default {
    components: {
      ToastVue,
      spinnerVue
    },
    props: {
      pObjClientes: {},
      pObjPaginacao: {}
    },
    data () {
      return {
        blockUI: {
          message: '',
          visibility: false
        },
        current_page: '0',
        tipoPedido: [],
        statusSelecionado: {},
        clientes: [],
        fieldsClientes: [
          {
            key: 'codCliente',
            label: 'Cód. Cli.',
            sortable: true,
            class: 'relCliCod'
          },
          {
            key: 'fantasia',
            label: 'Fantasia',
            sortable: true,
            class: 'relCliFant txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'razaoSocial',
            label: 'Razão Social',
            sortable: true,
            class: 'relCliRaz txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'cnpjCpf',
            label: 'CNPJ/CPF',
            sortable: true,
            class: 'relCliCnpj',
            formatter: this.formatterCnpjCpf
          },
          {
            key: 'email',
            label: 'Email',
            sortable: true,
            class: 'relCliEmail'
          },
          {
            key: 'telefone',
            label: 'Telefone',
            sortable: true,
            class: 'relCliTel'
          },
          {
            key: 'vencimento',
            label: 'Vencimento',
            sortable: true,
            class: 'relCliVen txtLeft'
          },
          {
            key: 'valor',
            label: 'Valor R$',
            sortable: true,
            class: 'relCliVal txtRight',
            formatter: this.formatterValue
          },
          {
            label: '',
            key: 'mobile',
            class: 'relCliMobile txtLeft'
          }
        ]
      }
    },
    created () {
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
    },
    watch: {
      pObjClientes: function (newVal, oldVal) { // watch it
        // console.log(JSON.stringify(newVal))
        this.clientes = newVal
      }
    },
    methods: {
      buscarClientesPorPagina: function () {
        let paginaCorrente = this.current_page - 1
        let paginacao = this.pObjPaginacao[paginaCorrente]
        // console.log(JSON.stringify(paginacao))
        let paramCliente = {tipoRelatorio: '0', paginacao: paginacao.pagina, registrosPorPagina: paginacao.registrosPorPagina}
        relatoriosService.listarClientes(paramCliente).then(response => {
          this.clientes = response.data.clientes
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      showMessage: function (message, title, variantColor) {
        this.message = message
        this.titleMsg = title
        this.variant = variantColor
        this.$bvToast.show('my-toast')
      },
      relatorioCliente: function () {
        this.blockUI.visibility = true
        this.blockUI.message = 'Listando clientes, aguarde...'
        relatoriosService.listarClientes().then(response => {
          this.clientes = response.data
        }).catch(error => {
          console.log(error)
          alert('Aconteceu alguma coisa!' + error)
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      },
      formatterValue: function (value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      formatterCnpjCpf: function (value) {
        if (value.length === 14) {
          value = value.replace(/^(\d{2})(\d)/, '$1.$2')
          value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          value = value.replace(/\.(\d{3})(\d)/, '.$1/$2')
          value = value.replace(/(\d{4})(\d)/, '$1-$2')
          return value
        }
        if (value.length === 11) {
          value = value.replace(/(\d{3})(\d)/, '$1.$2')
          value = value.replace(/(\d{3})(\d)/, '$1.$2')
          value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
          return value
        }
      }
    }
  }
</script>
<style scoped>
  .table {
    overflow-y: auto;
    max-height: 350px;
    font-size: 14px;
  }
  .imgTable {
    width: 50px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/relatorioClientesPendenciaVue.vue